"use strict";
module.exports = {
    randomQuote: require("./QuoteAPI/quoteAPI").randomQuote,
    randomTen: require("./QuoteAPI/quoteAPI").randomTen,
    getbyauthor: require("./QuoteAPI/quoteAPI").getbyauthor
};
